import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CustomersListType } from 'src/app/models';
import {
    Aircraftwatch,
    FavoriteAicraftData,
} from 'src/app/models/flight-watch';
import { CustomerinfobygroupService } from 'src/app/services/customerinfobygroup.service';
import {
    AircraftAssignModalComponent,
    NewCustomerAircraftDialogData,
    AircraftAssignResult,
} from 'src/app/shared/components/aircraft-assign-modal/aircraft-assign-modal.component';
import { FlightWatchMapSharedService } from '../services/flight-watch-map-shared.service';
import { SharedService } from 'src/app/layouts/shared-service';
import { JetNetInformationComponent } from '../../../shared/components/jetnet-information/jetnet-information.component';
import { JetNetService } from '../../../services/jetnet.service';
import { JetNet } from '../../../models/jetnet-information';
import { CallbackComponent } from 'src/app/shared/components/favorite-icon/favorite-icon.component';
import { defaultStringsEnum } from 'src/app/enums/strings.enums';
import { NullOrEmptyToDefault } from 'src/app/shared/pipes/null/NullOrEmptyToDefault.pipe';
import { AppDialogWrapperService } from '../../../ni-components/app-dialog-wrapper/app-dialog-wrapper.service';

@Component({
  providers: [NullOrEmptyToDefault],
  selector: 'app-aircraft-popup-container',
  templateUrl: './aircraft-popup-container.component.html',
  styleUrls: ['./aircraft-popup-container.component.scss'],
})
export class AircraftPopupContainerComponent {
  @Input() flightData: Aircraftwatch;
  @Input() isLoading: boolean;
    @Input() fboId: number;
    @Input() groupId: number;
    @Input() showFavoriteButton: boolean = false;
    @Output() clickEventListener: EventEmitter<any> = new EventEmitter<any>();

    public aircraftWatch: FavoriteAicraftData = {
        customerInfoByGroupId: 0,
        tailNumber: '',
        atcFlightNumber: '',
        aircraftTypeCode: '',
        isAircraftOnGround: false,
        flightDepartment: '',
        aircraftMakeModel: '',
        lastQuote: '',
        currentPricing: '',
        aircraftICAO: '',
        faaRegisteredOwner: '',
        origin: '',
        destination: '',
        isJetNetEnabled: false,
        favoriteAircraft: null,
        customerAircraftId: 0,
        isCustomerManagerAircraft: false,
        isFavorite: false,
        aircraftAssignResult: null,
        make: null,
        model: null
    };
    public hasAircraftAssigned = false;
    public customers: CustomersListType[] = [];
    public selectedFboId: number;
    public selectedGroupId: number;
    private newChanges: any;
    public hasJetNetInformation: boolean = false;
    public isJetNetOpened: boolean = false;

    public favoriteCallbackComponent = CallbackComponent.aircraft;
    public defaultStringsEnum = defaultStringsEnum;

    constructor(
        private customerInfoByGroupService: CustomerinfobygroupService,
        private router: Router,
        private flightWatchMapSharedService: FlightWatchMapSharedService,
        private sharedService: SharedService,
        private jetNetService: JetNetService,
        private nullOrEmptyToDefault: NullOrEmptyToDefault,
        private appDialogWrapperService: AppDialogWrapperService
    ) { }
    ngOnChanges(changes) {
        if(changes.flightData?.currentValue == null) return;

        this.aircraftWatch = changes.flightData.currentValue;
        this.aircraftWatch.make = this.aircraftMake;
        this.aircraftWatch.model = this.aircraftModel;
        if (
            changes.flightData?.currentValue?.atcFlightNumber &&
            changes.flightData?.currentValue?.atcFlightNumber == this.newChanges
        )
            return;
        this.hasJetNetInformation = false;
        this.isLoading = true;
        this.newChanges = changes.flightData.currentValue?.atcFlightNumber;

        this.getJetNetCustomerName();
    }
    ngOnInit(){
        if(this.fboId && this.groupId)
            this.getCustomersList(this.groupId,this.fboId);
    }
    get isJetNetIntegrationEnabled() {
        return this.sharedService.currentUser.isJetNetIntegrationEnabled;
    }
    get aircraftHasCustomer() {
        return !(
            this.aircraftWatch?.customerInfoByGroupId == null ||
            this.aircraftWatch?.customerInfoByGroupId == 0
        );
    }
    get isCustomerManagerButtonDisabled() {
        return (
            !this.hasAircraftAssigned ||
            this.sharedService.isCsr ||
            !this.aircraftHasCustomer
        );
    }
    get isJetNetButtonDisabled() {
        return (
            !this.hasJetNetInformation ||
            this.isJetNetOpened
        );
    }
    get companyDisplayText() {
        return !this.isJetNetIntegrationEnabled
            ? this.aircraftWatch?.flightDepartment ?? 'Jetnet not Enabled'
            : this.aircraftWatch?.flightDepartment ?? 'Info N/A on JETNET'        
    }

    get hasCustomer() {
        return this.aircraftWatch?.customerInfoByGroupId != null;
    }
    get aircraftMake() {
        return this.aircraftWatch.aircraftMakeModel
            ? this.aircraftWatch.aircraftMakeModel.split('/')[0] : null;
    }
    get aircraftModel() {
        return this.aircraftWatch.aircraftMakeModel
            ? this.aircraftWatch.aircraftMakeModel.split('/')[1] : null;
    }
    addAircraft() {
        const dialogWrapper = this.appDialogWrapperService.open<AircraftAssignResult>({
            title: 'Add Aircraft To Customer',
            component: AircraftAssignModalComponent,
            data: {
                customers: this.customers,
                tailNumber: this.aircraftWatch.tailNumber,
                make: this.aircraftMake,
                model: this.aircraftModel,
            } as NewCustomerAircraftDialogData,
            width: '450px',
        });

        dialogWrapper.afterClosed().subscribe((result: AircraftAssignResult) => {
            if (!result) {
                return; // User cancelled
            }
            this.updateAicraftData(result);
        });
    }
    favoriteClick(event: FavoriteAicraftData) {
        if(event.aircraftAssignResult != null){
            this.aircraftWatch.favoriteAircraft = event.favoriteAircraft;
            this.updateAicraftData(event.aircraftAssignResult);
        }
    }
    private updateAicraftData(result: any): void {
        this.hasAircraftAssigned = true;
        this.aircraftWatch.aircraftMakeModel = result.aircraftType;
        this.aircraftWatch.flightDepartment = result.company;
        this.aircraftWatch.tailNumber = this.flightData.tailNumber;
        this.aircraftWatch.customerInfoByGroupId = result.customerInfoByGroupID;
        this.aircraftWatch.isCustomerManagerAircraft = true;
        this.aircraftWatch.customerAircraftId = result.customerAircraftId;
        
        let aux = Object.assign({}, this.aircraftWatch);
        this.aircraftWatch = aux;

        this.flightWatchMapSharedService.updateCustomerAicraftData(
            this.aircraftWatch
        );       
    }
    getCustomersList(groupId, fboId) {
        this.customerInfoByGroupService
            .getCustomersListByGroupAndFbo(groupId, fboId)
            .subscribe((customers: any[]) => {
                this.customers = customers;
            });
    }
    goToCustomerManager(customerInfoByGroupId: number): void {
        this.clickEventListener.emit();
        this.router.navigate([
            './default-layout',
            'customers',
            customerInfoByGroupId,
        ]);
    }

    openJetNetInformation() {
        this.isJetNetOpened = true;
        const dialogWrapper = this.appDialogWrapperService.open<any>({
            title: 'JetNet Information',
            component: JetNetInformationComponent,
            data: this.aircraftWatch.tailNumber,
            width: '1100px'
        });

        dialogWrapper.afterClosed().subscribe((result: any) => {
            this.aircraftWatch.customerInfoByGroupId = result;
            this.isJetNetOpened = false;
        });
    }

    getJetNetCustomerName() {
        if (this.isJetNetIntegrationEnabled && (this.aircraftWatch?.tailNumber?.trim().length ?? 0) >= 2) {
            try {
                this.jetNetService.getJetNetInformationByTailNumber(this.aircraftWatch?.tailNumber).subscribe((response: JetNet) => {
                    if (response.aircraftresult != null) {
                        this.hasJetNetInformation = true;
                        this.aircraftWatch.flightDepartment = response.aircraftresult.companyrelationships[0].companyname.toUpperCase();
                        this.hasAircraftAssigned = true;
                    }
                    else
                        this.hasJetNetInformation = false;
                    this.isLoading = false;
                });
            }
            catch (e) {
                this.hasAircraftAssigned = false;
                this.hasJetNetInformation = false;
                this.isLoading = false;
            }
        }
        else if (this.aircraftWatch?.customerInfoByGroupId == null || this.aircraftWatch?.customerInfoByGroupId == 0) {
            this.hasAircraftAssigned = false;
            this.isLoading = false;
            this.hasJetNetInformation = false;
        }else{
            this.hasAircraftAssigned = true;
            this.isLoading = false;
            this.hasJetNetInformation = false;
        }
    }
}
